import { List } from "antd";
import React from "react";
import GlobalStoreContext from "../../context/GlobalStoreContext";
import Helper from "../../Helper";
import { Area } from "../../models/Area";
import DamnMappableAttachments from "../DamnPage/damnMappableAttachments";
import WaypointGuidance from "../DamnPage/WaypointGuidance/WaypointGuidance";
import WaypointStepView from "./WaypointStep";

interface Props {
    waypoint: Area;
    dropoff?: Area;
    title: React.ReactNode;
}

const WaypointDirections: React.FC<Props> = (props) => {
    const context = React.useContext(GlobalStoreContext);
    const [expanded, setExpanded] = React.useState<boolean>(false);

    const waypointSteps = props.waypoint.waypointDirection?.waypointSteps?.sort((a, b) => a.stepNumber - b.stepNumber);

    const startWaypointGuidance = (e) => {
        e.stopPropagation();
        // If we already have a user location, toggle the geolocation control first so that
        // any existing tracking session is reset before starting waypoint guidance.
        if (context.userLocation) {
            context.geoControlRef.current?.trigger();
        }
        context.setWaypointGuidance(true);
    };

    return (
        <>
            <React.Fragment>
                {waypointSteps && waypointSteps.length > 0 && (
                    <div className="p-4 bg-gray-50 rounded-lg">
                        <div className="flex flex-row w-full">
                            <div className="flex flex-col w-full gap-2">
                                <div className="flex items-center w-full justify-between">
                                    <div className="flex flex-col xl:flex-row  flex-1 w-full justify-between gap-2">
                                        {props.title}

                                        <DamnMappableAttachments mappable={props.waypoint} />
                                    </div>
                                </div>
                                <div className="flex flex-col items-center gap-4 justify-between">
                                    <button
                                        type="button"
                                        onClick={() => setExpanded((prev) => !prev)}
                                        className="text-xs text-gray-600 font-medium w-full text-center italic"
                                    >
                                        {expanded
                                            ? "Collapse Turn-By-Turn Guidance"
                                            : "Expand for Turn-By-Turn Guidance"}
                                    </button>
                                    {expanded && (
                                        <button
                                            onClick={startWaypointGuidance}
                                            className="cursor-pointer w-full text-center font-semibold border border-plot-slate p-2 rounded-lg hover:scale-110 hover:bg-plot-slate hover:text-plot-white transition-all duration-300"
                                        >
                                            Start Turn-By-Turn Guidance
                                        </button>
                                    )}
                                </div>
                            </div>
                        </div>

                        <List
                            className={Helper.classNames(
                                "overflow-hidden transition-all duration-300 ease-in-out",
                                expanded ? "max-h-[250px] opacity-100" : "max-h-0 opacity-0"
                            )}
                            dataSource={waypointSteps.filter((step) => !step._destroy && !step.hidden)}
                            renderItem={(step, index) => (
                                <List.Item key={index}>
                                    <WaypointStepView waypointStep={step} index={index} />
                                </List.Item>
                            )}
                        />
                    </div>
                )}
            </React.Fragment>

            <WaypointGuidance
                active={context.waypointGuidance}
                cancel={() => {
                    context.geoControlRef.current?.trigger();
                    context.setWaypointGuidance(false);
                }}
                waypoint={props.waypoint}
                dropoff={props.dropoff}
            />
        </>
    );
};

export default WaypointDirections;
